import React, {useState, useRef, useEffect} from 'react';
import {buildApiList} from '../../utils/buildApiList.js';

import {DocsBadge} from '../DocsBadge.jsx';

import Dropdown from "@hig/dropdown";
import SidebarLink from "./SidebarLink";
import './style.scss';

const NavSidebar = (props) => {

  const [data, setData] = useState(window.docIa);

  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);

  const [imageError, setImageError] = useState(false);
  const [badges, setBadges] = useState([]);


  useEffect(() => {
    async function waitForData() {
      while (!Array.isArray(window.docIa)) {
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }
    setData(window.docIa);
  }, [window.docIa]);

  // Allow manual setting of sidebar data from outside component
  // Used to fix timing issue when loading through Drupal site
  window.resetSidebar = (val) => {
    setData(val);
  };

  // Grab correct badge by comparing global api data with /payloads:
  useEffect(() => {
    async function getBadgeData() {
      const badge_data = await buildApiList()
      if (data) { for (let i = 0; i < badge_data.length; i++) {
        badge_data[i].title === data.api_name
          ? setBadges(badge_data[i].badges) 
          // Check for drupal title discrepancies:
          : badge_data[i].title.includes(data.api_name) || data.api_name.includes(badge_data[i].title) 
          ? setBadges(badge_data[i].badges) 
        : null
        // Check for drupal title discrepancies:
        data.api_name.includes("[Beta]") ? setBadges([...badges, "Beta"]) : null
        data.api_name.includes("(Beta)") ? setBadges([...badges, "Beta"]) : null
      }}
    }
    getBadgeData()
  }, [data])

  const pass = (id) => {
  };

  const toggleOpen = (e) => {
    setIsComponentVisible(!isComponentVisible);
  };

  const changeVersion = (version) => {
    let version_number = version.replace(/[^\d]*/, '');
    window.location.href = `/en/docs/${data.url_path}/v${version_number}`;
  };

  const getImage = () => {
    let fallback_src = props.resourceUrl + 'api_documentation/icons/default.svg';
    let img_src = props.resourceUrl + 'api_documentation/icons/' + data.url_path + '.svg';
    let pngs = ['a360', 'fusion-connect', 'hfdm'];
    if (pngs.indexOf(data.url_path) > -1) {
      img_src = props.resourceUrl + 'api_documentation/icons/' + data.url_path + '.png';
    }

    if (!imageError) {
      return (<img src={img_src} onError={(e) => {
        setImageError(true);
      }}/>);
    }

    return (<img src={fallback_src}/>);
  };

  if (!data || !data.url_path) {
    return (
      <div className={`adskf__sidebar-wrapper open-${isComponentVisible}`}
            ref={ref}></div>);
  }

  let version_current = data.doc_version.replace(/[^\d]/, '');
  let versions = {};
  if (data.old_versions) {
    versions = data.old_versions.reverse().map((value) => {
      return `Version ${value.replace(/[^\d]*/, '')}`;
    });
  }

    const links = [];
    let url = `/en/docs/${data.url_path}/${data.doc_version}`;

  data.children.forEach((link, index) => {
    let link_url = url + ('url_path' in link ? '/' + link.url_path : '');
    let link_children = link.children ? link.children.slice() : [];
    links.push(
      <SidebarLink 
        key={link.id} id={link.id} 
        url={link_url}
        name={link.display_name}
        links={link_children} href={null}
        parentToggleOpen={pass}
        parentAddTrail={pass}
        parentRemoveTrail={pass}
        followLink={props.followLink}></SidebarLink>
    );
  });

  function LifecycleBadgeContainer({badges, mobile}) {
    return mobile
      ? (
        <div css={{ display: "flex", marginLeft: 7 }}>
          {badges.map((badge, index) => (
            <div key={index}>
              <DocsBadge label={badge}/>
            </div>
          ))}
        </div>
      ) : (
        <div css={{ display: "flex", margin: "20px 7px 0 0" }}>
          {badges.map((badge, index) => (
            <div key={index}>
              <DocsBadge label={badge}/>
            </div>
          ))}
        </div>
      )
  }

  return (
    <div className={`adskf__sidebar-wrapper open-${isComponentVisible}`} ref={ref}>

      {/* Mobile View */}
      <div className="adskf__sidebar-mobile">
        <div className="adskf__sidebar-api-name">
          {getImage()}
          <span>{data.api_name}</span>
        </div>
        {badges
          ? <LifecycleBadgeContainer badges={badges} mobile/>
          : null}
        {/* These APIs don't come from the buildApiList(), so hard code the badges for now. */}
        {data.api_name == "BuildingConnected API"
          ? <LifecycleBadgeContainer badges={["New"]} mobile/>
          : null}
        <div className="adskf__sidebar-toggle">
          <a 
            data-test-id="documentation-sidebar-toggle-link"
            data-external-target="documentation-sidebar-toggle-link"
            className="adskf__sidebar-toggle-btn" 
            onClick={toggleOpen}>
          </a>
        </div>
      </div>

      {/* Desktop View */}
      <div className="adskf__sidebar">
        <div className="adskf__sidebar-toggle">
          <a 
            data-test-id="documentation-sidebar-toggle-link"
            data-external-target="documentation-sidebar-toggle-link"
            className="adskf__sidebar-toggle-btn" 
            onClick={toggleOpen}>
          </a>
        </div>
        <div className="adskf__sidebar-api">
          <div className="adskf__sidebar-api-name">
            {getImage()}
            <span>{data.api_name}</span>
          </div>
          {badges
            ? <LifecycleBadgeContainer badges={badges}/>
            : null}
          {/* These APIs don't come from the buildApiList(), so hard code the badges for now. */}
          {data.api_name == "BuildingConnected API"
            ? <LifecycleBadgeContainer badges={["New"]}/>
            : null}
          <div className="adskf__sidebar-api-version">
            {
              data.old_versions && data.old_versions.length > 1 ? <Dropdown
                  variant="line"
                  multiple={false}
                  options={versions}
                  defaultValue={`Version ${version_current}`}
                  onChange={changeVersion}
                />
                :
                <span>Version {version_current}</span>
            }
          </div>
        </div>
        <ul className="adskf__sidebar-menu" aria-labelledby="menuList">
          {links}
        </ul>
      </div>
    </div>
  );
  }
;

export default NavSidebar;

function useComponentVisible(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef(null);

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return {ref, isComponentVisible, setIsComponentVisible};
}
